module.exports = __webpack_public_path__ + "img/2023-22.c0fed147.jpg";